// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"265d877f","610":"793d0056","643":"5c7d8f46","681":"7d0a2f43","714":"25483245","764":"950478ba"}[chunkId] + ".chunk.js";
};